import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"
import Button from "../../Button"

// Updated file names for clarity:
import Step2ImageA from "../../../resources/tutorial/PROFESSIONAL_REG_2A.png"
import Step2ImageB from "../../../resources/tutorial/PROFESSIONAL_REG_2B.png"

const ArztRegistrationStep2: InstructionComponentProps = {
  name: "Schritt 2 von 3 – Email bestätigen",
  path: "/help/arzt/registration-step2",
  description:
    "Bestätigen Sie Ihre E-Mail-Adresse, um die Registrierung fortzusetzen.",
  both: [
    // First section: Code input screenshot
    <ImageTextComponent
      text={
        <>
          <h3 className="font-semibold text-lg">
            Verifikationscode aus der E-Mail einfügen
          </h3>
          <p>
            1. Öffnen Sie Ihr E-Mail-Postfach und suchen Sie nach der
            Bestätigungs-Mail, die wir Ihnen nach Schritt 1 geschickt haben.
            Der Versender der Mail lautet door-studie@kl.cit.tum.de.
          </p>
          <p className="mt-2">
            2. Kopieren Sie den darin enthaltenen <b>6-stelligen Code</b>.
          </p>
          <p className="mt-2">
            3. Tragen Sie diesen Code nun in das Feld <b>„Bestätigungscode hier eingeben“</b> ein.
          </p>
        </>
      }
      images={[Step2ImageA]}
      col={true}
    />,
    // Second section: Example of the code filled in + the green "Weiter" button
    <ImageTextComponent
      text={
        <>
          <h3 className="font-semibold text-lg">Weiter klicken</h3>
          <p>
            Nachdem Sie den Code eingefügt haben, erscheint er wie in diesem
            Beispiel. Überprüfen Sie noch einmal, ob Sie ihn korrekt
            eingegeben haben.
          </p>
          <p className="mt-2">
            Zum Abschluss klicken Sie auf den <b>grünen „Weiter“-Knopf</b>,
            um Ihre E-Mail-Adresse zu bestätigen und mit Schritt 3
            fortzufahren.
          </p>
        </>
      }
      images={[Step2ImageB]}
      col={true}
      
    />
  ]
}

export default ArztRegistrationStep2
